import { Position } from '../domain/models/position';

export class EditRouteViewModel {
    public jobId: string;
    public projectId: string;
    public name: string;
    public startDate: Date;
    public endDate: Date;
    public startTime: string;
    public endTime: string;
    public roadsegment: number;
    public interval: number;
    public route: any;
    public days: number[];
    public calculateSpectrogram: boolean;
    public calculateBudgetSpectrogram: boolean;
    public includeHistoricalData: boolean;
    public branchingAnalyse: boolean;
    public locations: Position[];
    public expectedRouteLength: number;
    public lineNumber: number;

    constructor(json?: any) {
        if (json) {
            this.jobId = json.jobId;
            this.projectId = json.projectId;
            this.name = json.name;
            this.startDate = json.startDate ? new Date(json.startDate) : null;
            this.endDate = json.endDate ? new Date(json.endDate) : null;
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.roadsegment = json.roadsegment;
            this.interval = json.interval;
            this.route = json.route;
            this.days = json.days;
            this.calculateSpectrogram = json.calculateSpectrogram;
            this.calculateBudgetSpectrogram = json.calculateBudgetSpectrogram;
            this.includeHistoricalData = json.includeHistoricalData;
            this.branchingAnalyse = json.branchingAnalyse;
            this.locations = json.locations;
            this.expectedRouteLength = json.expectedRouteLength;
            this.lineNumber = json.lineNumber;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/new-route/edit-route.viewModel.ts